export default "{{ data.title }}";